import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  ManageBusinessList: { loading: false, data: null, error: null }, //bank details list
  ManageBusinessCreate: { loading: false, data: null, error: null }, // Add bank details
  ManageBusinessUpdate: { loading: false, data: null, error: null }, //Update bank details

  invoiceItemMasterList: { loading: false, data: null, error: null },
  invoiceItemMasterCreate: { loading: false, data: null, error: null },
  invoiceItemMasterUpdate: { loading: false, data: null, error: null },
};

export const InvoiceItemMasterSlice = createSlice({
  name: "invoiceItemMaster",
  initialState,
  reducers: {
    fetchManageBusinessListRequest: (state, action) => {
      state.ManageBusinessList.loading = true;
      state.ManageBusinessList.error = null;
    },
    fetchManageBusinessListSuccess: (state, action) => {
      state.ManageBusinessList.data = action.payload;
      state.ManageBusinessList.loading = false;
      state.ManageBusinessList.error = null;
    },
    fetchManageBusinessListFailure: (state, action) => {
      state.ManageBusinessList.data = null;
      state.ManageBusinessList.loading = false;
      state.ManageBusinessList.error = action.payload;
    },
    ManageBusinessCreateRequest: (state, action) => {
      state.ManageBusinessCreate.loading = true;
      state.ManageBusinessCreate.error = null;
    },
    ManageBusinessCreateSuccess: (state, action) => {
      state.ManageBusinessCreate.data = action.payload;
      state.ManageBusinessCreate.loading = false;
      state.ManageBusinessCreate.error = null;
      state.ManageBusinessList = addNewManageBusinessSuccess(action.payload, {
        ...state.ManageBusinessList,
      });
    },
    ManageBusinessCreateFailure: (state, action) => {
      state.ManageBusinessCreate.data = null;
      state.ManageBusinessCreate.loading = false;
      state.ManageBusinessCreate.error = action.payload;
    },

    // InvoiceItemMaster fetch List
    fetchInvoiceItemMasterListRequest: (state, action) => {
      state.invoiceItemMasterList.loading = true;
      state.invoiceItemMasterList.error = null;
    },
    fetchInvoiceItemMasterListSuccess: (state, action) => {
      state.invoiceItemMasterList.data = action.payload;
      state.invoiceItemMasterList.loading = false;
      state.invoiceItemMasterList.error = null;
    },
    fetchInvoiceItemMasterListFailure: (state, action) => {
      state.invoiceItemMasterList.data = null;
      state.invoiceItemMasterList.loading = false;
      state.invoiceItemMasterList.error = action.payload;
    },

    // InvoiceItemMaster create
    InvoiceItemMasterCreateRequest: (state, action) => {
      state.invoiceItemMasterCreate.loading = true;
      state.invoiceItemMasterCreate.error = null;
    },
    InvoiceItemMasterCreateSuccess: (state, action) => {
      state.invoiceItemMasterCreate.data = action.payload;
      state.invoiceItemMasterCreate.loading = false;
      state.invoiceItemMasterCreate.error = null;
      state.invoiceItemMasterList = addNewInvoiceItemMasterSuccess(
        action.payload,
        {
          ...state.invoiceItemMasterList,
        }
      );
    },
    InvoiceItemMasterCreateFailure: (state, action) => {
      state.invoiceItemMasterCreate.data = null;
      state.invoiceItemMasterCreate.loading = false;
      state.invoiceItemMasterCreate.error = action.payload;
    },

    // Update
    InvoiceItemMasterUpdateRequest: (state, action) => {
      state.invoiceItemMasterUpdate.loading = true;
      state.invoiceItemMasterUpdate.error = null;
    },
    InvoiceItemMasterUpdateSuccess: (state, action) => {
      state.invoiceItemMasterUpdate.data = action.payload;
      state.invoiceItemMasterUpdate.loading = false;
      state.invoiceItemMasterUpdate.error = null;

      state.invoiceItemMasterList = updateInvoiceItemMasterSuccess(
        action.payload,
        state.invoiceItemMasterList
      );
    },
    InvoiceItemMasterUpdateFailure: (state, action) => {
      state.invoiceItemMasterUpdate.data = null;
      state.invoiceItemMasterUpdate.loading = false;
      state.invoiceItemMasterUpdate.error = action.payload;
    },
  },
});

function addNewManageBusinessSuccess(dataToUpdate, state) {
  state.data.data = [...state.data.data, dataToUpdate];
  state.data.total++;
  return state;
}

// addNewInvoiceItemMaster  Function
function addNewInvoiceItemMasterSuccess(dataToUpdate, state) {
  state.data.data = [dataToUpdate, ...state.data.data];
  state.data.total++;
  return state;
}
// update function updateInvoiceItemMasterSuccess
function updateInvoiceItemMasterSuccess(dataToUpdate, state) {
  state.data.data = state.data.data.map((value) => {
    if (value._id !== dataToUpdate._id) return value;
    return { ...value, ...dataToUpdate };
  });
  return state;
}

export const {
  fetchManageBusinessListRequest,
  fetchManageBusinessListSuccess,
  fetchManageBusinessListFailure,
  ManageBusinessCreateRequest,
  ManageBusinessCreateSuccess,
  ManageBusinessCreateFailure,

  fetchInvoiceItemMasterListRequest,
  fetchInvoiceItemMasterListSuccess,
  fetchInvoiceItemMasterListFailure,
  InvoiceItemMasterCreateRequest,
  InvoiceItemMasterCreateSuccess,
  InvoiceItemMasterCreateFailure,
  InvoiceItemMasterUpdateRequest,
  InvoiceItemMasterUpdateSuccess,
  InvoiceItemMasterUpdateFailure,
} = InvoiceItemMasterSlice.actions;

export const getManageBusinessSliceListState = (store) =>
  store.managebusiness?.ManageBusinessList;
export const getManageBusinessSliceCreateState = (store) =>
  store.managebusiness?.ManageBusinessCreate;

export const getInvoiceItemMasterListState = (store) =>
  store.invoiceItemMaster?.invoiceItemMasterList;

export default InvoiceItemMasterSlice.reducer;
